import { clearSession } from "./auth.js";

const baseRoute =
  process.env.REACT_APP_API_BASE_URL ||
  'https://fpsqrcodegeneratorbackend.worldvision.org.hk/';
  // "https://wvhk-fps-backend01-awcuetaaeubfhdcm.eastasia-01.azurewebsites.net";

const fetchOpts = (extra = {}) => ({
  credentials: "include",
  ...extra,
  headers: {
    ...(extra.headers || {}),
  },
});

const handleUnauthorized = (response) => {
  if (response.status === 401) {
    clearSession();
    if (window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
  }
};

const login = async (username, password) => {
  try {
    const response = await fetch(
      `${baseRoute}/login`,
      fetchOpts({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      })
    );
    if (!response.ok) {
      let detail = "Invalid credentials";
      try {
        const body = await response.json();
        detail = body.detail || detail;
      } catch (_) {
        /* ignore */
      }
      throw new Error(detail);
    }
    const data = await response.json();
    return { ok: true, msg: data };
  } catch (e) {
    return { ok: false, msg: e.message };
  }
};

const logout = async () => {
  try {
    await fetch(`${baseRoute}/logout`, fetchOpts({ method: "POST" }));
  } catch (_) {
    /* ignore network errors; still clear local profile */
  }
  clearSession();
};

const me = async () => {
  try {
    const response = await fetch(`${baseRoute}/me`, fetchOpts({ method: "GET" }));
    if (!response.ok) {
      return { ok: false, msg: null };
    }
    const data = await response.json();
    return { ok: true, msg: data };
  } catch (e) {
    return { ok: false, msg: null };
  }
};

const getDefaultByKey = async (k) => {
  try {
    const resp = await fetch(
      `${baseRoute}/fpsdefaults/${k}`,
      fetchOpts({ method: "GET" })
    );
    handleUnauthorized(resp);
    if (!resp.ok) {
      throw new Error("");
    }
    return await resp.text();
  } catch (error) {
    return "";
  }
};

const getXLSXTemplate = async (fileName = "FPS_QR_Code_Batch_Template.xlsx") => {
  const response = await fetch(
    `${baseRoute}/FPSQR-BatchGenTemplate`,
    fetchOpts({ method: "GET" })
  );
  handleUnauthorized(response);
  if (!response.ok) {
    throw new Error(`Template download failed (${response.status})`);
  }
  const blob = await response.blob();
  const fileURL = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileURL);
};

const getQRCodeVal = async (qrParams) => {
  try {
    const response = await fetch(
      `${baseRoute}/fpscreate`,
      fetchOpts({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(qrParams),
      })
    );

    handleUnauthorized(response);

    if (!response.ok) {
      var msg = await response.json();
      throw new Error(msg["detail"]);
    }
    const data = await response.json();
    let retData = { ok: response.ok, msg: data };
    return retData;
  } catch (e) {
    return { ok: false, msg: e.message };
  }
};

const getQRCodeBatch = async(batchList) =>{
  try {
    const resp = await fetch (
      `${baseRoute}/fpsbatchcreate` ,
      fetchOpts({
        method: 'POST'
      , headers: {"Content-Type" : "application/json"}
      , body: JSON.stringify(batchList)
      })
    );

    handleUnauthorized(resp);

    if (!resp.ok){
      var msg = await resp.json();
      throw new Error(msg["detail"])
    }

    var data = await resp.json();
    let retData = { ok: resp.ok , msg: data };
    return retData ;
  } catch (error) {
    return { ok: false , msg: error.message }; 
  }

}

let apis = {
  login: login,
  logout: logout,
  me: me,
  getDefaultByKey: getDefaultByKey,
  getXLSXTemplate: getXLSXTemplate,
  getQRCodeVal: getQRCodeVal,
  getQRCodeBatch:getQRCodeBatch
};

export default apis;
